import { render, staticRenderFns } from "./ManagePersonnel.vue?vue&type=template&id=8c623d48&scoped=true&"
import script from "./ManagePersonnel.vue?vue&type=script&lang=js&"
export * from "./ManagePersonnel.vue?vue&type=script&lang=js&"
import style0 from "./ManagePersonnel.vue?vue&type=style&index=0&id=8c623d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c623d48",
  null
  
)

export default component.exports